import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu-n105p",
  "use": "menu-n105p-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 16\" id=\"menu-n105p\"><g><path d=\"M0 2h15V0H0zM0 9h15V7H0zM0 16h15v-2H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol